import { render, staticRenderFns } from "./license.vue?vue&type=template&id=5b2cc542&scoped=true"
import script from "./license.vue?vue&type=script&lang=js"
export * from "./license.vue?vue&type=script&lang=js"
import style0 from "./license.vue?vue&type=style&index=0&id=5b2cc542&prod&lang=scss&scoped=true"
import style1 from "./license.vue?vue&type=style&index=1&id=5b2cc542&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2cc542",
  null
  
)

export default component.exports